import { PwaService } from '../pwa/pwa.service';
import { AuthenticationService } from '../admin/services/authentication.service';
import { AppConstant, GlobalConfig } from '../shared/constant/app.constant';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, OnChanges, SimpleChanges, Renderer2, ElementRef } from '@angular/core';
import { LoadingService } from '../shared/services/loading.service';
import swal from 'sweetalert2';
import { PushNotificationsService } from 'ng-push';
import { UserNotification } from '../shared/models/notification';
import { NotificationService } from '../shared/services/notification.service';
import { Message } from 'primeng/primeng';
import { FormGroup, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import * as CryptoJS from 'crypto-js';


@Component({
   selector: 'app-screen-lock',
    templateUrl: 'screen-lock.component.html',
    styleUrls: ['./css/screen-lock.scss']
})

export class ScreenLockComponent implements OnInit, OnChanges {

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private loadingService: LoadingService,
        private authService: AuthenticationService,
        private noticeService: NotificationService,
        private _pushNotifications: PushNotificationsService,
        private fb: FormBuilder,
        public pwa: PwaService,
        public renderer: Renderer2,
        private el: ElementRef
        ) {
    }
    @Input() active = false;
    displayTwoFactorAuth = false;
    allowSignoutPage = false;
    data: any = {};
    show = false;
    authenticating = false;
    message: any;
    title: any;
    cssClass: any;
    returnUrl: any;
    displayPasswordchange = false;
    msgs: Message[] = [];
    notificationList: UserNotification[];
    username: string;
    passwordForm: FormGroup;
    userSpecificTokenAccessEnabled: any;
    passwordInfo: string;

    // onLoginClicked(): void {
    //     // if (AppConstant.API_VERSION == true) {
    //     // } else {
    //     this.loginUser();
    //     // }
    // }

    // signIn(): void {
    //     this.loginUser();
    // }
    evt: any;
    
    ngOnInit() {

      this.authService.lockScreen$.subscribe(() => {
       this.authenticating = false;
      });
      this.activesDeactivateScreenLock();
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
        //// console.log('@login url --==> ', this.returnUrl);
        //// console.log('@login user --==> ', this.authService.lastUsername);
      this.passwordChangeForm();
      if (!('Notification' in window)) {
           // alert('This browser does not support desktop notification');
        }

      if (this._pushNotifications.permission !== 'denied') {
            this._pushNotifications.requestPermission();

            // if (this._pushNotifications.permission === 'granted') {
            //     this._pushNotifications.create(
            //         'Alert', {
            //             body: 'Hello there!',
            //             icon: 'assets/layout/images/icons/fbn_icon_1.png',
            //             data: '/dashboard'
            //         })
            //         .subscribe((res: any) => {
            //             ////console.log('notification', res);
            //             res['notification']['onclick'] = this.onNotificationClick;
            //             // this.route = res['notification']['data'];
            //             // cloe the notification after a specific period
            //             setTimeout(res['notification'].close.bind(res['notification']), 4000);
            //         },
            //         (err) => ////console.log(err)
            //         );
            // }
        }

    }

    ngOnChanges(changes: SimpleChanges): void {
     this.activesDeactivateScreenLock();
    }

    activesDeactivateScreenLock() {
      // if ( this.active) {
      //   this.renderer.addClass(this.el.nativeElement, 'show-login');

      // } else {
      //   this.renderer.addClass(this.el.nativeElement, 'hide-login');


      // }
    }

    installPwa() {
        this.pwa.promptEvent.prompt();
    }


    onPasswordChange() {
        let body = this.passwordForm.value;
        if (body.newPassword != body.confirmPassword) {
            swal(`${GlobalConfig.APPLICATION_NAME}`, "New password and confirm password does not match.", 'info');
            return;
        }
      

        this.authService.passwordChange(body).subscribe((res) => {
           
            if (res.success) {
                this.displayPasswordchange = false;
                swal(`${GlobalConfig.APPLICATION_NAME}`, res.message, 'success');
            }
            else {
                this.displayPasswordchange = true;
                swal(`${GlobalConfig.APPLICATION_NAME}`, res.message, 'error');
            }
        });
    }

    passwordChangeForm() {
        this.passwordForm = this.fb.group({
            username: ['', Validators.required],
            currentPassword: ['', Validators.required],
            newPassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
            confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])]
        },
            { validator: this.equalValueValidator('newPassword', 'confirmPassword') }
        );
    }

    equalValueValidator(targetKey: string, toMatchKey: string): ValidatorFn {
        return (group: FormGroup): { [key: string]: any } => {
            const target = group.controls[targetKey];
            const toMatch = group.controls[toMatchKey];
            if (target.touched || toMatch.touched) {
                const isMatch = target.value === toMatch.value;
               
                if (!isMatch && target.valid && toMatch.valid) {
                    toMatch.setErrors({ equalValue: targetKey });
                    const message = targetKey + ' != ' + toMatchKey;
                    return { 'equalValue': message };
                }
                if (isMatch && toMatch.hasError('equalValue')) {
                    toMatch.setErrors(null);
                }
            }

            return null;
        };
    }

    hideModal() {
        this.displayPasswordchange = false;
    }
    onNotificationClick(event) {
        event.preventDefault();
       
    }

    signIn() {
        const lastUser = sessionStorage.getItem('lastLoggedInUser');
        if (this.authenticating == true)
        if (this.authenticating == true) return;
        this.authenticating = true;
        this.loadingService.show();
        let body = {};
        if (AppConstant.API_VERSION === true) {
            let password = btoa(this.data.password);

            this.authService.getAuthToken(this.data.username, password).subscribe((res) => {
                this.username = this.data.username;
                let token = res && res.access_token;
                if (token) {
                let accesstoken = btoa(res.access_token);
                let expiry = btoa(res.expiry_date);
                let password = btoa(this.data.password);

                    body = {
                        username: this.data.username,
                        password: password,
                        encodedToken: accesstoken,
                        validTo: expiry,
                    };
                   this.authService.setRefreshToken(res.refresh_token);
                   this.authService.signInWithToken(body, token).subscribe((response) => {
                        this.loadingService.hide();
                        this.authenticating = false;
                        this.authService.UserProfile.isLoggedIn = true;

                        if (response.userInfo.sessionStatusInfo.isFirstLogin) {
                                this.passwordInfo = `This is the first time you are login to the Credit360, you are required to change your password.`
                                 this.passwordChangeForm();
                                this.passwordForm.controls['username'].setValue(this.username);
                                this.displayPasswordchange = true;
                                return;
                            }

                            if (response.userInfo.sessionStatusInfo.isPasswordExpired) {
                                this.passwordInfo = `Your current password has expired. You have need to change your password.`
                                this.passwordChangeForm();
                                this.passwordForm.controls['username'].setValue(this.username);
                                this.displayPasswordchange = true;
                                return;
                            }

                            if (response.success === true) {

                               this.authService.setUserInfo(response.userInfo);
                                this.authService.setLoggedInUser(response.access_token);
                                this.authService.setTokenExpirationTime(response.expiration);
                                this.authService.setLastUsername(response.userInfo.userName);
                                this.authService.setLoggedInUserActivities(response.userInfo.activities);

                                if (response.userInfo.activities != undefined) {
                                    let twoFactorAuthEnabled = response.userInfo.activities.indexOf("2FA")
                                    if (twoFactorAuthEnabled > -1) {
                                        this.displayTwoFactorAuth = true;
                                        this.authService.lockScreen$.next(null);
                                        this.loadingService.hide();
                                    } else {
                                        if (lastUser === response.userInfo.userName) {
                                            this.authService.lockScreen$.next(null);
                                            this.loadingService.hide();
                                          } else {
                                            this.router.navigate([this.returnUrl]);
                                          }
                                       
                                    }
                                }
                               } else {
                               
                                this.showMessage('Wrong username or password!', 'error', 'Authentication Error');
                            }
                        
                    }, (err) => {
                       
                       this.authenticating = false;
                        this.loadingService.hide();
                        this.showMessage(err, 'error', 'Authentication Error');
                    });
                } else {
                    this.authenticating = false;
                    this.loadingService.hide();
                    this.showMessage('Wrong username or password!!', 'error', 'Authentication Error');
                }

            }, (err) => {
                 this.authenticating = false;

                this.loadingService.hide();
                this.showMessage(err, 'error', 'Authentication Error');
            });

        } else {
            body = {
                username: this.data.username,
                password: this.data.password
            };
        }

    }
    detailMessage: string = "You have an active session running on another system. You are required to sign out on the previous system, to end the session";

    showWarn() {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: '', detail: this.detailMessage });
    }
    showMessage(message: string, cssClass: string, title: string) {
        this.message = message;
        this.title = title;
        this.cssClass = cssClass;
        this.show = true;
    }

    hideMessage(event) {
        this.show = false;
    }
    signOut(evt) {
        evt.preventDefault();
        let body = {};
        if (AppConstant.API_VERSION === true) {

            this.authService.getAuthToken(this.data.username, this.data.password).subscribe((res) => {
               let token = res && res.access_token;

                if (token) {

                    body = {
                        username: this.data.username,
                        password: this.data.password,
                        encodedToken: res.access_token,
                        validTo: res.expiry_date
                    };

                    this.authService.UserProfile.isLoggedIn = true;

                    this.authService.endActiveSession(body).subscribe((response) => {
                        if (response.success === true) {
                            this.allowSignoutPage = false;
                            swal(GlobalConfig.APPLICATION_NAME, response.message, "success")
                            this.router.navigate(['/auth/login']);
                        } else {
                            this.data.username = "";
                            this.data.password = "";
                        }
                    });
                }
            });
        }
    }
    getNotificationForFinalState() {
        this.noticeService.getNotificationForFinalState().subscribe((res) => {
            this.notificationList = res;
            let tempNotification = this.notificationList;
            tempNotification.forEach((el) => {
                this.spawnNotification('Alert', 'assets/images/notification_logo.png', el.message);
                this._pushNotifications.create(
                    'Alert', {
                        body: el.message,
                        icon: 'assets/images/notification_logo.png',
                        data: el.actionUrl,
                        renotify: true,
                    }).subscribe((res) => {
                       setTimeout(res['notification'].close.bind(res['notification']), 4000);
                    }, (err) => {
                       });

            });
        }, (err) => {
           
        });
    }

    spawnNotification(theBody, theIcon, theTitle) {
        let options = {
            body: theBody,
            icon: theIcon
        }
        let n = new Notification(theTitle, options);
        setTimeout(n.close.bind(n), 5000);
    }

    logOut() {
        this.authService.UserProfile.isLoggedIn = false;
        this.authService.logOffSystem().subscribe((res) => {
     }, (err) => {
           
        });
        sessionStorage.removeItem('auth');

        if (AppConstant.REMEMBER_LAST_WORKAREA) {
            this.router.navigate(['/auth/login'], {
                queryParams: { returnUrl: this.authService.redirectUrl }
            });
            return;
        }
        this.router.navigate(['/auth/login']);
    }


}

